import React from "react";
import {
  Box,
  Image as ChakraImage,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
} from "@chakra-ui/react";
import Image from "next/image";

export function MdxImage({ size = "large", src, alt }: { size?: "small" | "large"; src?: string; alt?: string }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Box
        pos="relative"
        width="100%"
        maxWidth={size === "small" ? "60%" : "100%"}
        borderRadius="base"
        bg={{ base: "white", md: "brand.backgroundSecondary.light" }}
        p={{ base: 0, md: "smaller" }}
        mx="auto"
        mt="bigger"
        mb={size === "small" ? "bigger" : undefined}
        cursor="zoom-in"
        pointerEvents={["none", "none", "auto"]}
        onClick={onOpen}
      >
        <Image
          src={src?.startsWith("/") ? `https://www.master-7rqtwti-od3d6y3dmsppq.us-4.platformsh.site${src}` : src ?? ""}
          alt={alt ?? "Image."}
          sizes="100%"
          width={700}
          height={350}
          style={{
            objectFit: "contain",
            width: "100%",
            height: "auto",
            minWidth: "100%",
            maxHeight: "90vh",
            borderRadius: "8px",
          }}
        />
      </Box>
      <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(8px)" />
        <ModalContent maxWidth="container.section" maxHeight="80vh" mt={0}>
          <ModalBody bg="white" p={6}>
            <ChakraImage
              mx="auto"
              src={src?.startsWith("/") ? `https://www.master-7rqtwti-od3d6y3dmsppq.us-4.platformsh.site${src}` : src}
              objectFit="contain"
              maxH="160vh"
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
